module.exports = __webpack_public_path__ + "img/inception_eng_assessment.cc862c6e.svg";